import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  paper: {
    width: "100%",
    textAlign: "center",
    padding: theme.spacing(1),
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    border: "1px solid #fff",
    transition: "border 0.4s ease-in-out",
    "&:hover, &:focus": {
      boxShadow: "2px 2px 9px 2px rgba(0,0,0,0.1)",
    },
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.up("xl")]: {
      padding: theme.spacing(2.5),
    },
  },
  paperDisabled: {
    "&:hover, &:focus": {
      boxShadow: "0 0 0 0 rgba(0,0,0,0)",
    },
  },
  title: {
    fontSize: 12,
    fontWeight: 500,
    margin: theme.spacing(1, "auto"),
    [theme.breakpoints.up("md")]: {
      margin: theme.spacing(1.5, "auto"),
      fontSize: 18,
    },
    [theme.breakpoints.up("xl")]: {
      margin: theme.spacing(2, "auto"),
      fontSize: 20,
    },
  },
  titleDisabled: {
    color: 'rgba(174, 178, 186, 1)',
  },
  secondTitle: {
    fontSize: "1.1em",
    color: "#AEB2BA",
    fontWeight: 400,
  },
  chipSkeleton: {
    borderRadius: '32px !important',
    transform: 'scale(1,1) !important',
  },
  chip: {
    maxWidth: "150px",
    width: "90%",
    fontSize: 16,
    borderRadius: 20,
    fontWeight: 700,
    height: 40,
    marginTop: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      fontSize: 30,
      borderRadius: 30,
      height: 60,
      marginTop: theme.spacing(1.5),
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: 40,
      borderRadius: 35,
      height: 70,
      marginTop: theme.spacing(2),
    },
    "& .MuiChip-label": {
      paddingTop: "8px",
    },
  },
  loadingContainer: {
    padding: "1.6em",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  highlight: {
    border: "1px solid rgb(249,208,55)",
    boxShadow: "2px 2px 9px 2px rgba(255,213,48,0.37)",
  },
}));
